import { InputField, isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Formik, FormikHelpers as FormikActions, FormikProps } from 'formik';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import * as Yup from 'yup';
import { ISettingsPage } from '../shared';
import * as S from '../shared.styles';

const maxLength = 45;
const schema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
});

interface IName {
    firstName: string;
    lastName: string;
}

export const Name: React.FunctionComponent = inject('rootStore')(
    observer(
        (props: ISettingsPage): React.ReactElement => {
            const rootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const currentUser = rootStore.settingsStore.getCurrentUser(_.get(props, 'rootStore.userId'));
            const initial: IName = {
                firstName: _.get(currentUser, 'first', ''),
                lastName: _.get(currentUser, 'last', ''),
            };

            const handleSubmit = async (values: IName, { setSubmitting }: FormikActions<IName>): Promise<void> => {
                if (currentUser) {
                    const { firstName, lastName } = values;
                    setSubmitting(true);
                    await rootStore.settingsStore.changeUserName(currentUser, firstName, lastName);
                    setSubmitting(false);
                    // NB: trigger re-initialization with changed values
                    _.assign(initial, values);
                }
            };
            const handleSave = (formik: FormikProps<IName>): (() => Promise<void>) => {
                // NB: avoid non-async formik.submitForm for now
                return async (): Promise<void> => {
                    await handleSubmit(formik.values, formik);
                };
            };

            return (
                <Formik
                    enableReinitialize={true}
                    initialValues={initial}
                    validationSchema={schema}
                    onSubmit={handleSubmit}>
                    {(formik: FormikProps<IName>): React.ReactElement => (
                        <S.SubCategoryItem>
                            {isTabletPortraitDown() && (
                                <S.ReturnLink to="/settings/overview">
                                    {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                                </S.ReturnLink>
                            )}
                            <S.SubCategoryH1>What is your name?</S.SubCategoryH1>

                            <S.SubCategoryForm>
                                <S.InputGroup>
                                    <S.Label>First Name</S.Label>
                                    <S.FormField name="firstName" maxLength={maxLength} component={InputField} />
                                </S.InputGroup>
                                <S.InputGroup>
                                    <S.Label>Last Name</S.Label>
                                    <S.FormField name="lastName" maxLength={maxLength} component={InputField} />
                                </S.InputGroup>
                            </S.SubCategoryForm>
                            <S.ButtonGroup
                                useNotify={true}
                                onCancel={formik.resetForm}
                                onSave={handleSave(formik)}
                                changed={formik.dirty}
                            />
                        </S.SubCategoryItem>
                    )}
                </Formik>
            );
        },
    ),
);
